import { render, staticRenderFns } from "./GiveAccessToEmployeeWizard.vue?vue&type=template&id=0308c70e&scoped=true"
import script from "./GiveAccessToEmployeeWizard.vue?vue&type=script&lang=js"
export * from "./GiveAccessToEmployeeWizard.vue?vue&type=script&lang=js"
import style0 from "./GiveAccessToEmployeeWizard.vue?vue&type=style&index=0&id=0308c70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308c70e",
  null
  
)

export default component.exports